module.exports = __webpack_public_path__ + "img/Nova.1b0d6fe9.svg";